var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91733 12.147C1.94796 11.8713 1.96328 11.7335 2.00498 11.6046C2.04198 11.4903 2.09426 11.3816 2.1604 11.2813C2.23494 11.1682 2.33301 11.0702 2.52913 10.874L11.3333 2.06986C12.0697 1.33348 13.2636 1.33348 14 2.06986C14.7364 2.80624 14.7364 4.00015 14 4.73653L5.19579 13.5407C4.99967 13.7368 4.90161 13.8349 4.78857 13.9094C4.68827 13.9756 4.5795 14.0279 4.46521 14.0649C4.33638 14.1066 4.19855 14.1219 3.92289 14.1525L1.66664 14.4032L1.91733 12.147Z",
    stroke: "#F7665F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPen);
export default __webpack_public_path__ + "static/media/map-pen.66020bfc07a33c80158a0f6d58846b86.svg";
export { ForwardRef as ReactComponent };